import React, { useState, useEffect } from 'react';
import { useEscapeClose } from '../../../utils/SamuiUtils';
import { useModalKeyboardNavigation, scrollToRow, getRowStyle, getKeyboardInstructions } from '../../../utils/ModalKeyboardNavigation';

const BankModal = ({
    showBankModal,
    handleBankClose,
    bankDataList,
    onRowSelectBank
}) => {
    // สถานะการค้นหา
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredBankDataList, setFilteredBankDataList] = useState(bankDataList);
    const [selectedRowIndex, setSelectedRowIndex] = useState(0); // เพิ่ม state สำหรับเลือกแถว

    useEscapeClose(showBankModal, handleBankClose);
    
    // เพิ่ม keyboard navigation
    useModalKeyboardNavigation(
        showBankModal,
        filteredBankDataList,
        selectedRowIndex,
        setSelectedRowIndex,
        onRowSelectBank,
        handleBankClose
    );

    // ฟิลเตอร์ข้อมูลเมื่อ searchTerm หรือ bankDataList เปลี่ยนแปลง
    useEffect(() => {
        setFilteredBankDataList(
            bankDataList.filter(bank =>
                bank.Bank_Code.toLowerCase().includes(searchTerm.toLowerCase()) ||
                bank.B_Name_TH.toLowerCase().includes(searchTerm.toLowerCase()) ||
                bank.B_Name_EN.toLowerCase().includes(searchTerm.toLowerCase())
            )
        );
        setSelectedRowIndex(0); // รีเซ็ตการเลือกแถวเมื่อข้อมูลเปลี่ยน
    }, [searchTerm, bankDataList]);

    useEffect(() => {
        if (showBankModal) {
            setSearchTerm('');
            setSelectedRowIndex(0); // รีเซ็ตการเลือกแถวเมื่อเปิด modal
        }
    }, [showBankModal]);

    return (
        <>
            <div className={`modal fade ${showBankModal ? 'show d-block' : ''}`} tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">รายชื่อธนาคาร</h5>
                            <button type="button" className="close" onClick={handleBankClose}>
                                <span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="ค้นหา รหัสธนาคาร หรือ ชื่อธนาคาร"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>
                            <div className="table-responsive" style={{ maxHeight: '650px', overflowY: 'auto' }}>
                                <table className="table table-striped table-hover">
                                    <thead className="thead-dark">
                                        <tr>
                                            <th className="text-center" style={{ width: '150px' }}>รหัสธนาคาร</th>
                                            <th className="text-center">ชื่อธนาคาร (TH)</th>
                                            <th className="text-center">ชื่อธนาคาร (EN)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredBankDataList && filteredBankDataList.length > 0 ? (
                                            filteredBankDataList.map((bank, index) => (
                                                <tr
                                                    key={bank.Bank_Master_Id || index}
                                                    onClick={() => {
                                                        setSelectedRowIndex(index); // อัปเดต selectedRowIndex เมื่อคลิก
                                                        onRowSelectBank(bank);
                                                    }}
                                                    style={getRowStyle(index, selectedRowIndex)}>
                                                    <td className="text-center">{bank.Bank_Code}</td>
                                                    <td>{bank.B_Name_TH}</td>
                                                    <td>{bank.B_Name_EN}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="3" className="text-center">
                                                    <h5>ไม่พบข้อมูล</h5>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="text-left" style={{ fontSize: "12px", color: "#666", marginRight: "auto" }}>
                                {getKeyboardInstructions('ธนาคาร')}
                            </div>
                            <button className="btn btn-danger" onClick={handleBankClose}>
                                ปิด (ESC)
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {showBankModal && <div className="modal-backdrop fade show"></div>}
        </>
    );
};

export default BankModal;
